import { cn } from '@/lib/utils'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

export function Logo({ size = 'md', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
  }

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <span className={cn('font-bold text-[#1976D2]', sizeClasses[size])}>
        QxProveIt
      </span>
      <span className="hidden text-sm text-gray-600 sm:inline">
        Where Quality means Prove It
      </span>
    </div>
  )
}

export function LogoText({ size = 'md', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl',
  }

  return (
    <span className={cn('font-bold text-[#1976D2]', sizeClasses[size], className)}>
      QxProveIt
    </span>
  )
}

export function LogoIcon({ className = '' }: { className?: string }) {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <span className="text-2xl font-bold text-[#1976D2]">Q</span>
    </div>
  )
}
